import {
  DrugItem,
  FastSearchCategory,
  FastSearchTradeNames,
  FetchAttr
} from '../types';
import { getData } from '../utils';

export type GetFastDrugSearhRequest = {
  text: string;
  categoryId?: string;
};

export type GetFastDrugSearhResponse = {
  drugs: DrugItem[];
  categories: FastSearchCategory[];
  tradeNames?: FastSearchTradeNames[];
};

const requestUrl = (url: string, text: string, categoryId: string): string => {
  const paramsString = new URLSearchParams({
    ...(text && { text }),
    ...(categoryId && { categoryId })
  });
  return `${url}?${paramsString.toString()}`;
};

const getFastDrugSearch = async (
  input: GetFastDrugSearhRequest,
  attr?: FetchAttr
): Promise<GetFastDrugSearhResponse> => {
  const response = await getData(
    requestUrl(`drug/search/fast/v2/`, input.text, input.categoryId),
    attr
  );
  return response;
};

export default getFastDrugSearch;
